import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireDagre } from '../node_modules/dagre/index.js';

var dagreExports = requireDagre();
var dagre = /*@__PURE__*/getDefaultExportFromCjs(dagreExports);

export { dagreExports as d, dagre as default };
//# sourceMappingURL=index.js.map
